import { SERVER_URL } from "../../api";
import axios from 'axios';
import { getHeaderWithToken } from "../../helpers/func";

export const DELETE_SUPPLY_REQUEST = 'DELETE_SUPPLY_REQUEST';
export const DELETE_SUPPLY_SUCCESS = 'DELETE_SUPPLY_SUCCESS';
export const DELETE_SUPPLY_ERROR = 'DELETE_SUPPLY_ERROR';


export const deleteSupply = (id) => {
    let headers = getHeaderWithToken();

    return dispatch => {
        return new Promise(function (resolve, reject) {
            dispatch({
                type: DELETE_SUPPLY_REQUEST
            })
            axios({
                method: 'DELETE',
                url: `${SERVER_URL}v1/supply/${id}`,
                headers: headers,
            }).then(function (response) {
                dispatch({
                    type: DELETE_SUPPLY_SUCCESS,
                    payload: response
                })
                resolve(response);
            })
                .catch(function (error) {
                    dispatch({
                        type: DELETE_SUPPLY_ERROR,
                        payload: error
                    })
                    reject(error)
                })
        })
    }
}
